import { render } from "./App.vue?vue&type=template&id=593dcc7a&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=593dcc7a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Luis\\Documents\\Code\\LEAGUES\\creator-app-3\\creator-app\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593dcc7a"]])

export default __exports__